
import Vue from 'vue';
import { AmazonExtensionItem, AmazonOrderListItem, api } from '@/services/api';
import { formatDate } from '@/services/date';
import { visualizeAmount } from '@/services/visualizer';

export default Vue.extend({
    data() {
        return {
            orders: [] as AmazonOrderListItem[],
            query: "",
            from: "",
            to: "",
            matchStatus: "",
            limit: 100
        }
    },
    async mounted() {
        await this.refresh();
    },
    methods: {
        async refresh() {
            this.orders = await api.listAmazonOrders({
                query: this.query,
                from: this.from,
                to: this.to,
                matchStatus: this.matchStatus,
                limit: this.limit
            });
        },
        money(amount: number): string {
            return visualizeAmount(amount);
        },
        formatDate(date: string): string {
            return formatDate(new Date(date));
        },
        orderDate(order: AmazonOrderListItem): string {
            return order.date ? this.formatDate(order.date) : order.rawDate;
        },
        quantity(item: AmazonExtensionItem): string {
            const pieces = [];
            if (item.quantity) {
                pieces.push(`${item.quantity}x`);
            }
            if (item.amountCents != null) {
                pieces.push(this.money(item.amountCents));
            }
            return pieces.join(" ");
        },
        itemMeta(item: AmazonExtensionItem): string {
            return [this.quantity(item), item.merchant || ""]
                .filter(part => part.length > 0)
                .join(" · ");
        },
        expenseMatchLabel(expense: { id: number; date: string; description: string }): string {
            return `#${expense.id} · ${this.formatDate(expense.date)} · ${expense.description}`;
        }
    },
    computed: {
        totalVisibleSpend(): number {
            return this.orders.reduce((total, order) => total + (order.totalCents || 0), 0);
        }
    }
})
